import { CustomSelectType } from './CustomSelect'

export const getSelectItemKey = (item: CustomSelectType | string, key: 'label' | 'value' = 'label') =>
    typeof item === 'object' ? item[key] : item

export const getSelectItemIcon = (item: CustomSelectType | string) => (typeof item === 'object' ? item.icon : null)
